export default "__VITE_ASSET__FhQlc0sD__"